import { createElementIdSlice } from '../utils/action/createElementSlice';
export const RadioListState = createElementIdSlice({
    elementName: 'radio-list',
    initialState: {},
    reducers: {},
});
